import { CommonModule, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, signal } from '@angular/core';
import { CircularSpinnerComponent } from '../circular-spinner/circular-spinner.component';

@Component({
  selector: 'keep-aspect-ratio-image',
  standalone: true,
  imports: [CommonModule, NgOptimizedImage, CircularSpinnerComponent],
  templateUrl: './keep-aspect-ratio-image.component.html',
  styleUrls: ['./keep-aspect-ratio-image.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KeepAspectRatioImageComponent {
  @Input() aspectRatio?: string;
  protected imageSrc = signal<string>('/assets/images/default-image.jpeg');
  protected isLoading = signal<boolean>(true);

  @Input() set src(src: string) {
    if (src) {
      this.imageSrc.set(src);
    }
  }
}
